/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React from 'react';
import firebase from 'firebase';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import { Alert } from '@material-ui/lab';
import { getErrorMessage } from '../../utils/firebaseConfig';
import OutlinedPasswordInput from '../../core/OutlinedPasswordInput';
import Copyright from '../../core/Copyright';
import { useFormStyles } from '../../core/styles';

export default function SignUpForm() {
  const classes = useFormStyles();

  const [state, setState] = React.useState({
    fullname: '',
    email: '',
    password: '',
    passwordConfirmation: '',
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setState({ ...state, showError: false });
  };

  const setError = (translatedError, error) => {
    setState({
      ...state,
      error: translatedError,
      showError: true,
    });
    // eslint-disable-next-line no-console
    console.error(error);
  };

  const validateFields = (fullname, email, password, passwordConfirmation) => {
    if (!fullname || !email || !password || !passwordConfirmation) {
      setState({
        ...state,
        error: 'Por favor, preencha todos os campos!',
        showError: true,
      });
      // eslint-disable-next-line no-console
      console.error('Missing required fields');
      return false;
    }
    if (password !== passwordConfirmation) {
      setState({
        ...state,
        error: 'Senha e confirmação de senha diferentes',
        showError: true,
      });
      // eslint-disable-next-line no-console
      console.error('Password and confirmation does not match');
      return false;
    }
    return true;
  };

  const signUpHandler = async (event) => {
    event.preventDefault();
    const {
      fullname, email, password, passwordConfirmation,
    } = state;

    const update = {
      displayName: fullname,
    };

    if (validateFields(email, fullname, password, passwordConfirmation)) {
      try {
        await firebase.auth().createUserWithEmailAndPassword(email, password);
        await firebase.auth().signInWithEmailAndPassword(email, password);
        await firebase.auth().currentUser.updateProfile(update);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        setError(getErrorMessage(error), error.message);
      }
    }
  };

  const { error, showError } = state;

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          CADASTRAR
        </Typography>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField
                autoComplete="fullname"
                name="fullname"
                variant="outlined"
                required
                fullWidth
                id="fullname"
                label="Nome Completo"
                onChange={handleChange}
                autoFocus
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="E-mail"
                name="email"
                autoComplete="email"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <OutlinedPasswordInput
                id="password"
                name="password"
                label="Senha"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <OutlinedPasswordInput
                id="password-confirmation"
                name="passwordConfirmation"
                label="Confirmação de Senha"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} />
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={signUpHandler}
          >
            CADASTRAR
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="signin" variant="body2">
                Já tem uma conta? Entrar
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright showImage />
      </Box>
      <Snackbar open={showError} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </Container>
  );
}
